import { type Interval, isEqualTime } from "~/tools/date-time";
import type { Time } from "~/tools/date-time/time";
import { Impulse, batch, untrack } from "~/tools/impulse";
import { max } from "~/tools/max";
import { min } from "~/tools/min";

export class State {
	private readonly start = Impulse<undefined | Time>(undefined, {
		compare: isEqualTime,
	});

	private readonly end = Impulse<undefined | Time>(undefined, {
		compare: isEqualTime,
	});

	public readonly interval = Impulse<undefined | Interval>((scope) => {
		const start = this.start.getValue(scope);
		const end = this.end.getValue(scope);

		if (start == null || end == null || isEqualTime(start, end)) {
			return undefined;
		}

		return { start: min(start, end), end: max(start, end) };
	});

	public onBrushStart(timestamp: Time): void {
		this.start.setValue(timestamp);
	}

	public onBrushMove(timestamp: Time): void {
		if (untrack(this.start) != null) {
			this.end.setValue(timestamp);
		}
	}

	public onBrushEnd(): void {
		batch(() => {
			this.start.setValue(undefined);
			this.end.setValue(undefined);
		});
	}
}
